import client from "./client";

export const getTrainingContent = async (): Promise<any> => {
  return client
    .get(`/content/training`)
    .then(response => response.data.response);
};

export const getHelpContent = async (): Promise<any> => {
  return client
    .get(`/content/help`)
    .then(response => response.data.response);
};

export const getChangesContent = async (): Promise<any> => {
  return client
    .get(`/content/changes`)
    .then(response => response.data.response);
};

export const getAsset = async (id: string): Promise<any> => {
  return client
    .get(`/content/asset/${id}`)
    .then(response => response.data.response);
}

export const getAssessment = async (): Promise<any> => {
  return client
    .get('/content/assessment')
    .then(response => response.data.response);
}
